/*------------------------------------*\
    NAV
\*------------------------------------*/
class Nav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        const toggle = document.querySelector('[data-nav-toggle]');
        const body = document.querySelector('body');

        toggle.addEventListener('click', evt => {
            // Scroll the nav to the top
            self.elem.scrollTop = 0;
            // Toggle active class on toggle button
            toggle.classList.toggle('is-active');
            // Toggle active class on nav
            self.elem.classList.toggle('is-active');
            // Toggle scrolling on body
            body.classList.toggle('is-no-scroll');
        });
    }
}

export default Nav;
